import { push } from 'react-router-redux';

const { currentClassRoomId } = require('@core/selectors/classroom');

const navigateToGroups = (groupSetId) => (dispatch, getState) => {
  const state = getState();
  const classRoomId = currentClassRoomId(state);
  let url = `/dashboard/${classRoomId}/people/groups`;
  if (groupSetId) {
    url = `${url}/${groupSetId}`;
  }

  dispatch(push(url));
};

export default navigateToGroups;
